module.exports = __webpack_public_path__ + "static/media/ballpen-blur-close-up-computer-461077.c3c3b122.png";